import { getStoryblokApi } from '@storyblok/react'
import { ImpressionStory } from './types'

export async function fetchImpression(slug: string, preview?: boolean): Promise<ImpressionStory> {
  const storyblok = getStoryblokApi()

  const { data } = await storyblok.get(`cdn/stories/impressionen/${slug}`, {
    version: preview ? 'draft' : 'published',
    resolve_links: 'story',
  })

  return data.story
}
